<template>
  <div class="default-layout">
    <topbar />
    <header-component />

    <lazy-hydrate :trigger-hydration="$store.state.drawer.drawerOpened">
      <drawer-menu class="mobile-only" />
    </lazy-hydrate>

    <nuxt />

    <lazy-hydrate v-slot="{ hydrated }" when-visible>
      <div class="lazy_hydrate">
        <footer-component
          v-if="hydrated"
          :store-code="$store.state.storeCode"
        />
      </div>
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import urlCouponApplier from '~/mixins/url-coupon-applier'
import Topbar from '~/components/Topbar.vue'
import HeaderComponent from '~/components/header/Header.vue'
import { CURRENCIES, LOCALES } from '~/config'

const DrawerMenu = () =>
  import(
    /* webpackChunkName: "drawer-menu"  */ '~/components/header/header-drawer/HeaderDrawer.vue'
  )
const FooterComponent = () =>
  import(/* webpackChunkName: "footer"  */ '~/components/footer/Footer.vue')

export default {
  layout: 'default',
  components: {
    LazyHydrate,
    Topbar,
    HeaderComponent,
    DrawerMenu,
    FooterComponent,
  },
  mixins: [urlCouponApplier],
  errorCaptured(error, vm, info) {
    this.$sentry.captureException(error, { vm, info })
  },
  computed: {
    canonicalUrl() {
      return `https://www.gocase${this.$isBrStore ? '.com.br' : '.com'}${
        this.$route.path
      }`
    },
  },
  mounted() {
    this.$store.dispatch('checkUserLogin')

    this.setCurrencyChanged()
  },
  methods: {
    currentHref() {
      return this.$store.state.currentHost + this.$route.fullPath
    },
    setCurrencyChanged() {
      const lastCurrency = this.$lastCurrency
      const newCurrency = this.$route?.query?.currency

      if (this.$isBrStore || !CURRENCIES.includes(newCurrency)) {
        return
      }

      this.$axios
        .$get('/currency/set', {
          params: {
            ...this.$store.getters.storeInfo,
            currency: lastCurrency || this.$currency,
            new_currency: newCurrency,
          },
        })
        .then((res) => {
          sessionStorage.setItem('v4_last_currency', newCurrency)
        })
        .catch((err) => {
          this.$displayTopMessage(this.$t('action_error'), { type: 'error' })
          this.$sentry.captureException(err.response || err)
        })
    },
  },
  head() {
    return {
      bodyAttrs: {
        class: 'goasyourself',
      },
      link: [
        {
          rel: 'canonical',
          href: this.canonicalUrl,
        },
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          rel: 'dns-prefetch',
          href: 'https://static-production.gocase.com.br',
        },
        { rel: 'preconnect', href: 'https://static-production.gocase.com.br' },
        {
          rel: 'dns-prefetch',
          href: this.$nuxt.$config.baseBrowserURL,
        },
        {
          rel: 'preconnect',
          href: this.$config.baseBrowserURL,
          crossorigin: 'use-credentials',
        },
        { rel: 'dns-prefetch', href: 'https://ik.imagekit.io' },
        { rel: 'preconnect', href: 'https://ik.imagekit.io' },
        { rel: 'dns-prefetch', href: 'https://www.googletagmanager.com' },
        { rel: 'preconnect', href: 'https://www.googletagmanager.com' },
        { rel: 'dns-prefetch', href: 'https://polyfill.io' },
        { rel: 'preconnect', href: 'https://polyfill.io' },
        ...(this.$i18n.locale === 'pt-BR'
          ? [
              {
                rel: 'alternate',
                hreflang: 'pt-br',
                href: this.currentHref(),
              },
            ]
          : LOCALES.filter((loc) => loc !== 'pt-BR').map((loc) => ({
              rel: 'alternate',
              hreflang: loc,
              href: this.currentHref(),
            }))),
      ],
    }
  },
}
</script>
